import React from 'react'
import ReactDOM from 'react-dom/client'
import { ConfigProvider } from 'antd'
import MerchantPc from './merchantPc'
import '@common/styles/global.css'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#fb693e',
        },
      }}
    >
      <MerchantPc />
    </ConfigProvider>
  </React.StrictMode>
)
